import { Config } from '@interfaces/mainInterfaces';
import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '@utils/utils';

type LoginStatus = 'LOADING' | 'LOGGED' | 'NOT_LOGGED';

class InitialStateProps {
    config: Config | null = null;
    isMobile = null;
    isLoggedIn: LoginStatus = 'LOADING';
}

const initialState: InitialStateProps = new InitialStateProps();

const reducer = (state = initialState, action): InitialStateProps => {
    switch (action.type) {
        case actionTypes.SAVE_CONFIG:
            return saveConfig(state, action);
        case actionTypes.SET_IS_MOBILE:
            return setIsMobile(state, action);
        case actionTypes.SET_IS_LOGGED_IN:
            return setIsLoggedIn(state, action);
        default:
            return state;
    }
};

export default reducer;

/* SAVE CONFIG */
const saveConfig = (state, action) => {
    return updateObject(state, {
        config: action.config,
    });
};

/* SET MOBILE VIEW */
const setIsMobile = (state, action) => {
    return updateObject(state, {
        isMobile: action.isMobile,
    });
};

const setIsLoggedIn = (state, action) => {
    return updateObject(state, {
        isLoggedIn: action.isLoggedIn,
    });
};
